(ns practitest.frontend.components.instances2
  (:require
    [clojure.string :as str]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.components.charts :as charts]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.subs :as subs]
    [practitest.frontend.testset2.events :as testset2]
    [practitest.frontend.testset2.subs :as testset.subs]
    [practitest.frontend.routing.backend-routes :as broutes]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

(defn instances-status-graph []
  (let [state (reagent/atom "instances")]
    (fn []
      (let [status-colors @(re-frame/subscribe [::subs/status-colors])
            {:keys [run_status_bar aggregated_step_runs]}
            (:graphs @(re-frame/subscribe [::subs/entity :testset]))
            instances-data {:labels (map first run_status_bar)
                            :datasets [{:label "Instances"
                                        :data (map last run_status_bar)
                                        :bg-colors (map status-colors (map first run_status_bar))}]
                            :cutout "80%"}
            steps-data {:labels (map first aggregated_step_runs)
                        :datasets [{:label "Steps"
                                    :data (map last aggregated_step_runs)
                                    :bg-colors (map status-colors (map first aggregated_step_runs))}]
                        :cutout "80%"}]
        [:div.instances-status-graph
         [:div.instances-graph-meta
          [:div.graph-title.text-nowrap (get-translation "testset.instances.dashboard-status.title"
                                                         "Run Status")]
          [:div.graph-subtitle (get-translation "testset.instances.dashboard-status.subtitle"
                                                "Test Level")]
          [:select
           {:value @state
            :on-change (fn [e]
                         (reset! state (-> e .-target .-value)))}
           [:option {:value "instances"} "Instances"]
           [:option {:value "steps"} "Steps"]]]
         [:div.instances-graph-data
          [charts/mux-doughnut (if (= "instances" @state) instances-data steps-data)]]]))))

;; TODO: should we just normalize the colors elsewhere?
;;       this is a hack
(defn add-transparency [color alpha]
  (let [canvas (.createElement js/document "canvas")
        ctx (.getContext canvas "2d")]
    (set! (.-height canvas) 1)
    (set! (.-width canvas) 1)
    (set! (.-fillStyle ctx) color)
    (.fillRect ctx 0 0 1 1)
    (let [img-data (.getImageData ctx 0 0 1 1)
          r (aget img-data "data" 0)
          g (aget img-data "data" 1)
          b (aget img-data "data" 2)]
      (str "rgba(" r ", " g ", " b ", " alpha ")"))))

(defn instances-progress-graph []
  (let [status-colors @(re-frame/subscribe [::subs/status-colors])
        {:keys [instance_progress]} (:graphs @(re-frame/subscribe [::subs/entity :testset]))
        [series days] instance_progress
        raw-datasets (mapv (fn [{:keys [name data]}]
                             (let [color (get status-colors name)]
                               {:label name
                                :data data
                                :color color
                                :bg-color (add-transparency color 0.5)}))
                          series)]
    [:div.instances-progress-graph
     [:div.instances-graph-meta
      [:div.graph-title.text-nowrap (get-translation "testset.instances.dashboard-progress.title"
                                         "Instances Progress")]
      [:div.graph-subtitle (get-translation "testset.instances.dashboard-progress.subtitle"
                                            "Last 4 weeks")]]
     [:div.instances-graph-data
      [charts/line-area-chart {:labels days
                               :datasets raw-datasets}]]]))


(def dashboard-collapsed-key "-instances-dashboard-collapsed")

(defn get-dashboard-collapsed [project-id]
  (cljs.reader/read-string (dom/get-item (str project-id dashboard-collapsed-key))))

(defn set-dashboard-collapsed [project-id value]
  (dom/set-item (str project-id dashboard-collapsed-key) value))

(defn instances-dashboard []
  (let [current-project @(re-frame/subscribe [::subs/current-project])
        project-id (:id current-project)
        state (reagent/atom {:dashboard-collapsed? (get-dashboard-collapsed project-id)})]
    (fn []
      (let [collapsed? (:dashboard-collapsed? @state)]
        [:<>
         [:div.instances-dashboard
          {:class (dom/classes-pairs-v :collapsed collapsed?)}
          [:div.instances-section-header
           {:class (dom/classes-pairs-v :collapsed collapsed?)}
           [:div.instances-collapse-button
            {:on-click (fn [_e]
                         (swap! state update :dashboard-collapsed? not)
                         (set-dashboard-collapsed project-id (:dashboard-collapsed? @state)))}
            (if collapsed?
              [icons/mux-arrow-down]
              [icons/mux-arrow-up])]
           [:span.instances-title
            {:class (dom/classes-pairs-v :collapsed collapsed?)}
            (get-translation "testset.instances.dashboard-header" "Instances Dashboard")]]
          (when-not collapsed?
            [:div.instances-section-body
             (if (pos? @(re-frame/subscribe [::testset.subs/testset-instances-total-count]))
               [:div.instances-graphs-container
                [instances-status-graph]
                [:div.vertical-line]
                [instances-progress-graph]]
               (get-translation "testset.instances.dashboard-no-data-yet"
                                "No data yet, start inserting instances"))])]]))))

(comment

  (require '[re-frame.db])
  (tap> re-frame.db/app-db)

  (re-frame/dispatch [::testset2/fetch-graphs])
  )
